import { render, staticRenderFns } from "./safePhone.vue?vue&type=template&id=73c5035a&scoped=true"
import script from "./safePhone.vue?vue&type=script&lang=js"
export * from "./safePhone.vue?vue&type=script&lang=js"
import style0 from "@/styles/index.styl?vue&type=style&index=0&id=73c5035a&prod&lang=stylus&scoped=true&external"
import style1 from "./safePhone.vue?vue&type=style&index=1&id=73c5035a&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c5035a",
  null
  
)

export default component.exports